import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getPolicies, getPoliciesLoading } from 'resources/policies/selectors';
import { getUser } from 'resources/user/selectors';
import { getGLArchetype } from 'lib/glArchetype';
import { trackStructEvent } from 'services/TrackingService';
import { onlyUSTraffic } from 'services/ConfigurationService';

const GL_ARCHETYPE_EVENT_KEY = 'gl_archetype_event_fired';

export const useGLArchetypeTracking = (): void => {
  const policies = useSelector(getPolicies);
  const loading = useSelector(getPoliciesLoading);
  const user = useSelector(getUser);
  const hasFired = useRef(false);

  useEffect(() => {
    // Skip if not a US customer, still loading, no user, or already fired this session
    if (!onlyUSTraffic()) return;
    if (loading) return;
    if (!user.customerAccountId) return;
    if (hasFired.current) return;
    if (sessionStorage.getItem(GL_ARCHETYPE_EVENT_KEY)) return;

    const glArchetype = getGLArchetype(policies);

    trackStructEvent({
      action: 'login_rendered',
      label: `login_${glArchetype}`,
      property: user.customerAccountId,
    });

    sessionStorage.setItem(GL_ARCHETYPE_EVENT_KEY, 'true');
    hasFired.current = true;
  }, [policies, loading, user.customerAccountId]);
};

export default useGLArchetypeTracking;
